import React from 'react';

const SEO = ({ title, description, canonical, name, type, image }) => {
    return (
        <>
            {/* Standard metadata tags - React 19 will hoist these to the <head> */}
            <title>{title}</title>
            <meta name='description' content={description} />
            {canonical && <link rel="canonical" href={canonical} />}

            {/* Open Graph tags (Facebook, LinkedIn, etc.) */}
            <meta property="og:type" content={type || 'website'} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            {image && <meta property="og:image" content={image} />}
            <meta property="og:site_name" content={name || 'ToyTrade.pk'} />
            {canonical && <meta property="og:url" content={canonical} />}

            {/* Twitter tags */}
            <meta name="twitter:card" content={image ? "summary_large_image" : "summary"} />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            {image && <meta name="twitter:image" content={image} />}
        </>
    );
};

export default SEO;
